import { AxiosResponse } from 'axios';

import { CreateUserFileRequestType } from './index';

import { CommonResponseType } from 'api/authApi';
import { authServiceClient } from 'config';
import { UserFileType } from 'state';

export const fetchUserFileRequest = (inspectionFileId: string) => {
  return authServiceClient.get<UserFileType, AxiosResponse<UserFileType>, string>(
    `/user-file/${inspectionFileId}`,
  );
};

export const createUserFileRequest = (data: CreateUserFileRequestType) => {
  return authServiceClient.post<
    UserFileType,
    AxiosResponse<UserFileType>,
    CreateUserFileRequestType
  >(`/user-file`, data);
};

export const editUserFileRequest = (userFile: CreateUserFileRequestType) => {
  return authServiceClient.put<
    CommonResponseType,
    AxiosResponse<UserFileType>,
    CreateUserFileRequestType
  >(`/user-file/${userFile.inspectionFileId}`, userFile);
};
